import { useTranslation } from "react-i18next";
import { useTenant } from "../../context/Tenant";

export const usePageTitle = (
  titleKey: string,
  additionalParams?: Record<string, string | number | boolean | undefined>
) => {
  const { t } = useTranslation();
  const { tenant } = useTenant();
  document.title = t(titleKey, {
    tenantName: tenant.tenantName,
    ...additionalParams,
  });
};
